
import { defineNuxtPlugin, useRuntimeConfig } from '#imports';
import PrimeVue from 'primevue/config';

import BadgeDirective from 'primevue/badgedirective';
import Tooltip from 'primevue/tooltip';
import Ripple from 'primevue/ripple';
import StyleClass from 'primevue/styleclass';
import FocusTrap from 'primevue/focustrap';
import AnimateOnScroll from 'primevue/animateonscroll';
import KeyFilter from 'primevue/keyfilter';



export default defineNuxtPlugin(({ vueApp }) => {
  const runtimeConfig = useRuntimeConfig();
  const config = runtimeConfig?.public?.primevue ?? {};
  const { usePrimeVue = true, options = {} } = config;
  const pt = {};
  const theme = { theme: undefined || options?.theme };

  usePrimeVue && vueApp.use(PrimeVue, { ...options, ...pt, ...theme });
  
  vueApp.directive('Primebadge', BadgeDirective);
vueApp.directive('Primetooltip', Tooltip);
vueApp.directive('Primeripple', Ripple);
vueApp.directive('Primestyleclass', StyleClass);
vueApp.directive('Primefocustrap', FocusTrap);
vueApp.directive('Primeanimateonscroll', AnimateOnScroll);
vueApp.directive('Primekeyfilter', KeyFilter);
});
        